import React from "react";
import PropTypes from "prop-types";

const Badge = props => (
  <span className="fable:bg-orange-700 fable:rounded fable:text-white fable:p-2 fable:text-sm fable:font-bold">
    {props.title}
  </span>
);

Badge.propTypes = {
  title: PropTypes.string.isRequired
};

export default Badge;
